import styled from 'styled-components'

const step = 4

interface ISpace {
  width?: string
  height?: string
  mt?: number
  mr?: number
  mb?: number
  ml?: number
  pt?: number
  pr?: number
  pb?: number
  pl?: number
}

const get = (param: number | undefined): number => {
  if (!param) {
    return 0
  }
  return typeof param === 'number' ? param * step : step
}

const margin = ({ mt, mr, mb, ml }: ISpace) =>
  `${get(mt)}px ${get(mr)}px ${get(mb)}px ${get(ml)}px`

const padding = ({ pt, pr, pb, pl }: ISpace) =>
  `${get(pt)}px ${get(pr)}px ${get(pb)}px ${get(pl)}px`

export const Space = styled.div<ISpace>`
  margin: ${(props) => margin(props)};
  padding: ${(props) => padding(props)};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`
